<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="REQUERIMENTO DE MATERIAIS" page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} "
            show-change="true" image-title="assets/img/desktop.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/requisicoes']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="form-row">
        <div class="col-sm-8 pt-2">
          <div class="form-row">
            <div class="col-sm-12 d-flex justify-content-between">
              <div class="d-flex justify-content-between" style="font-weight: bold; color: #009688 ">
                <p>RECEBEDOR:</p>
                <p class="ml-2">{{entidade.usuario?.nome?.toUpperCase()}}</p>
              </div>
              <div class="d-flex justify-content-between text-primary" style="font-weight: bold;">
                <p>DATA:</p>
                <p class="ml-2"> {{entidade.data_cadastro |
                  date:'dd/MM/yyyy':'GMT'}}</p>
              </div>
            </div>
          </div>
          <div *ngIf="entidade.status === 'E'" class="row">
            <div class="col-12">
              <div class="alert alert-danger">
                Requisição estornada em <b>{{entidade.data_estorno | date:'dd/MM/yyyy':'GMT'}}</b>
                pelo usuário <b>{{entidade.usuario_estorno?.nome}}</b>
                com a justificativa <u>{{entidade.motivo_estorno}}</u>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-4" />
          <div class="form-row">
            <div class="col-sm-7 form-group">
              <label for="setor_almoxarifado">Setor</label>
              <input readonly [value]="entidade.setor_almoxarifado?.setor?.nome" type="text"
                class="form-control-plaintext form-control text-center">
            </div>
            <div class="form-group col-sm-5">
              <label for="destinatario">Destinatário</label>
              <input readonly [value]="entidade.destinatario" type="text"
                class="form-control-plaintext form-control text-center">
            </div>
          </div>
          <div class="form-row" *ngIf="entidadeForm.value.devolucao">
            <div class="col-sm-12 form-group">
              <label for="motivo_devolucao">Motivo Devolução</label>
              <textarea readonly [value]="entidade.motivo_devolucao" class="form-control-plaintext form-control pl-2"
                id="obs" rows="3"></textarea>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-4 col-xl-4">
          <div class="form-row pl-3">
            <div class="col-sm-11 offset-1">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item text-white d-flex justify-content-between align-items-center"
                    [ngClass]='corStatusRequisicao(entidade.status)'>
                    <i class="fa " [ngClass]='iconStatusRequisicao(entidade.status)' style="font-size: 18px;"></i>
                    <span class="float-right">{{tituloStatusRequisicao(entidade.status)}}</span>
                  </li>
                  <li class="list-group-item text-right">
                    <span *ngIf="entidade.devolucao" class="badge badge-danger">Devolução</span>
                    <span *ngIf="!entidade.devolucao" class="badge badge-success">Retirada</span>
                  </li>
                  <li class="list-group-item">Recusado
                    <span class="float-right">{{valorRecusado() | number:'1.5-5'}}</span>
                  </li>
                  <li class="list-group-item">Aceito
                    <span class="float-right">{{valorAceito() | number:'1.5-5'}}</span>
                  </li>
                  <li class="list-group-item font-weight-bold">Requisitado <span
                      class="float-right font-weight-bold">{{valorRequisitado() | number:'1.5-5'}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <lib-requisicao-item [setor_almoxarifado]="entidadeForm.get('setor_almoxarifado').value"
            [requisicao]="entidadeForm.value" [(lista)]="itens" [somenteVisualizar]="true"></lib-requisicao-item>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
  </div>
</div>